export class ReceiptModel {
  BeneficiaryName = '';
  imageData: any;
  CountryCodeTo = '';
  TransferAmount = '';
  payerLogo: any;
  branchLogo: any;
  DeliveryMethod = '';
  AmountLocal = '';
  PayingAgentId = '';
  PayingAgentLocationId = '';
  Commission = '';
  MarketingBalance = '';
  TotalAmount = '';
  Rate = '';
  ProgramId = '0';
  CurrencyCodeFrom = 'USD';
  CurrencyCodeTo = '';
  PayingAgent = '';
  PayingAgentLocation = '';
  ItemId = '';
  BankId = '';
}



// WEBPACK FOOTER //
// ./src/app/models/Receipt/receiptModel.ts